import React from 'react';
import Card from '../../ui/Card';
import DescriptionPanel from '../../ui/DescriptionPanel';
import { TrendingUpIcon, TrendingDownIcon, AwardIcon } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar } from 'recharts';
const TechnicianPerformanceDashboard: React.FC = () => {
  const kpis = [{
    title: 'First-Time Fix %',
    value: '78.4%',
    change: '+2.1%',
    isPositive: true
  }, {
    title: 'Avg Jobs per Technician',
    value: '6.8',
    change: '+0.5',
    isPositive: true
  }, {
    title: 'Technician Productivity Score',
    value: '82.5',
    change: '+3.2',
    isPositive: true
  }];
  const regionWorkloadData = [{
    region: 'Delhi NCR',
    technicians: 45,
    avgJobs: 7.2,
    utilization: 85
  }, {
    region: 'Mumbai',
    technicians: 38,
    avgJobs: 6.9,
    utilization: 82
  }, {
    region: 'Bangalore',
    technicians: 35,
    avgJobs: 7.5,
    utilization: 88
  }, {
    region: 'Chennai',
    technicians: 32,
    avgJobs: 6.5,
    utilization: 78
  }, {
    region: 'Pune',
    technicians: 28,
    avgJobs: 6.8,
    utilization: 80
  }, {
    region: 'Hyderabad',
    technicians: 26,
    avgJobs: 6.3,
    utilization: 76
  }, {
    region: 'Ahmedabad',
    technicians: 24,
    avgJobs: 6.1,
    utilization: 74
  }, {
    region: 'Kolkata',
    technicians: 22,
    avgJobs: 5.9,
    utilization: 72
  }];
  const topTechniciansData = [{
    name: 'Rajesh Kumar',
    ftf: 85.2,
    jobs: 8.2,
    rating: 4.8,
    productivity: 92
  }, {
    name: 'Amit Sharma',
    ftf: 82.5,
    jobs: 7.9,
    rating: 4.7,
    productivity: 89
  }, {
    name: 'Suresh Patel',
    ftf: 80.8,
    jobs: 7.5,
    rating: 4.6,
    productivity: 86
  }, {
    name: 'Vijay Singh',
    ftf: 78.5,
    jobs: 7.2,
    rating: 4.5,
    productivity: 83
  }, {
    name: 'Priya Sharma',
    ftf: 77.2,
    jobs: 7.0,
    rating: 4.5,
    productivity: 81
  }, {
    name: 'Neha Reddy',
    ftf: 76.8,
    jobs: 6.8,
    rating: 4.4,
    productivity: 80
  }, {
    name: 'Anil Kumar',
    ftf: 75.5,
    jobs: 6.5,
    rating: 4.4,
    productivity: 78
  }, {
    name: 'Deepak Joshi',
    ftf: 74.2,
    jobs: 6.3,
    rating: 4.3,
    productivity: 76
  }];
  const feedbackData = [{
    category: 'Technical Skills',
    score: 4.6
  }, {
    category: 'Communication',
    score: 4.4
  }, {
    category: 'Timeliness',
    score: 4.5
  }, {
    category: 'Professionalism',
    score: 4.7
  }, {
    category: 'Problem Solving',
    score: 4.3
  }];
  const technicianStatsData = [{
    id: 'TECH-001',
    name: 'Rajesh Kumar',
    region: 'Delhi NCR',
    specialization: 'Electrical',
    experience: 8,
    jobsCompleted: 245,
    avgJobsPerDay: 8.2,
    firstTimeFix: 85.2,
    avgResolutionTime: 2.1,
    customerRating: 4.8,
    productivity: 92,
    certifications: 'ASE, L1',
    status: 'Active'
  }, {
    id: 'TECH-002',
    name: 'Amit Sharma',
    region: 'Mumbai',
    specialization: 'Mechanical',
    experience: 7,
    jobsCompleted: 238,
    avgJobsPerDay: 7.9,
    firstTimeFix: 82.5,
    avgResolutionTime: 2.3,
    customerRating: 4.7,
    productivity: 89,
    certifications: 'ASE, L2',
    status: 'Active'
  }, {
    id: 'TECH-003',
    name: 'Suresh Patel',
    region: 'Bangalore',
    specialization: 'Electronics',
    experience: 6,
    jobsCompleted: 225,
    avgJobsPerDay: 7.5,
    firstTimeFix: 80.8,
    avgResolutionTime: 2.4,
    customerRating: 4.6,
    productivity: 86,
    certifications: 'ASE',
    status: 'Active'
  }, {
    id: 'TECH-004',
    name: 'Vijay Singh',
    region: 'Chennai',
    specialization: 'HVAC',
    experience: 5,
    jobsCompleted: 216,
    avgJobsPerDay: 7.2,
    firstTimeFix: 78.5,
    avgResolutionTime: 2.6,
    customerRating: 4.5,
    productivity: 83,
    certifications: 'ASE',
    status: 'Active'
  }, {
    id: 'TECH-005',
    name: 'Priya Sharma',
    region: 'Pune',
    specialization: 'Electrical',
    experience: 5,
    jobsCompleted: 210,
    avgJobsPerDay: 7.0,
    firstTimeFix: 77.2,
    avgResolutionTime: 2.7,
    customerRating: 4.5,
    productivity: 81,
    certifications: 'L1',
    status: 'Active'
  }, {
    id: 'TECH-006',
    name: 'Neha Reddy',
    region: 'Hyderabad',
    specialization: 'Body & Trim',
    experience: 4,
    jobsCompleted: 204,
    avgJobsPerDay: 6.8,
    firstTimeFix: 76.8,
    avgResolutionTime: 2.8,
    customerRating: 4.4,
    productivity: 80,
    certifications: 'L1',
    status: 'Active'
  }, {
    id: 'TECH-007',
    name: 'Anil Kumar',
    region: 'Ahmedabad',
    specialization: 'Mechanical',
    experience: 4,
    jobsCompleted: 195,
    avgJobsPerDay: 6.5,
    firstTimeFix: 75.5,
    avgResolutionTime: 2.9,
    customerRating: 4.4,
    productivity: 78,
    certifications: 'ASE',
    status: 'Active'
  }, {
    id: 'TECH-008',
    name: 'Deepak Joshi',
    region: 'Kolkata',
    specialization: 'Electronics',
    experience: 3,
    jobsCompleted: 189,
    avgJobsPerDay: 6.3,
    firstTimeFix: 74.2,
    avgResolutionTime: 3.0,
    customerRating: 4.3,
    productivity: 76,
    certifications: 'L1',
    status: 'Active'
  }, {
    id: 'TECH-009',
    name: 'Sanjay Gupta',
    region: 'Delhi NCR',
    specialization: 'HVAC',
    experience: 3,
    jobsCompleted: 182,
    avgJobsPerDay: 6.1,
    firstTimeFix: 73.5,
    avgResolutionTime: 3.1,
    customerRating: 4.2,
    productivity: 74,
    certifications: 'L1',
    status: 'Active'
  }, {
    id: 'TECH-010',
    name: 'Pooja Iyer',
    region: 'Bangalore',
    specialization: 'Electrical',
    experience: 2,
    jobsCompleted: 175,
    avgJobsPerDay: 5.8,
    firstTimeFix: 72.8,
    avgResolutionTime: 3.2,
    customerRating: 4.2,
    productivity: 72,
    certifications: 'L1',
    status: 'Active'
  }, {
    id: 'TECH-011',
    name: 'Rahul Mehta',
    region: 'Mumbai',
    specialization: 'Body & Trim',
    experience: 2,
    jobsCompleted: 168,
    avgJobsPerDay: 5.6,
    firstTimeFix: 71.5,
    avgResolutionTime: 3.3,
    customerRating: 4.1,
    productivity: 70,
    certifications: 'L1',
    status: 'On Leave'
  }, {
    id: 'TECH-012',
    name: 'Anjali Desai',
    region: 'Chennai',
    specialization: 'Mechanical',
    experience: 2,
    jobsCompleted: 162,
    avgJobsPerDay: 5.4,
    firstTimeFix: 70.2,
    avgResolutionTime: 3.4,
    customerRating: 4.0,
    productivity: 68,
    certifications: 'L1',
    status: 'Active'
  }];
  const getUtilizationColor = (utilization: number) => {
    if (utilization >= 85) return 'bg-green-500';
    if (utilization >= 75) return 'bg-yellow-500';
    return 'bg-orange-500';
  };
  const getFTFColor = (ftf: number) => {
    if (ftf >= 80) return 'text-green-600 font-bold';
    if (ftf >= 75) return 'text-yellow-600 font-semibold';
    return 'text-orange-600 font-semibold';
  };
  const getRatingColor = (rating: number) => {
    if (rating >= 4.5) return 'text-green-600 font-bold';
    if (rating >= 4.2) return 'text-yellow-600 font-semibold';
    return 'text-orange-600 font-semibold';
  };
  const getProductivityColor = (score: number) => {
    if (score >= 85) return 'text-green-600 bg-green-50';
    if (score >= 75) return 'text-yellow-600 bg-yellow-50';
    return 'text-orange-600 bg-orange-50';
  };
  const getStatusColor = (status: string) => {
    if (status === 'Active') return 'text-green-600 bg-green-50 border-green-300';
    return 'text-gray-600 bg-gray-50 border-gray-300';
  };
  return <div data-id="element-849">
      <DescriptionPanel title="Technician Performance & Productivity" description="Comprehensive analysis of field technician performance including first-time fix rates, job completion metrics, customer satisfaction ratings, and productivity scores. Monitor workload distribution across regions and identify top performers to optimize service delivery." insights={['First-time fix rate at 78.4% - 2.1% improvement over last quarter', 'Top performer Rajesh Kumar achieving 85.2% FTF with 4.8/5 customer rating', 'Bangalore region leading with 88% technician utilization and 7.5 avg jobs/day', 'Technical Skills rated highest at 4.6/5 in customer feedback']} data-id="element-850" />
      {/* KPI Tiles */}
      <div className="mb-8" data-id="element-851">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-852">
          Technician Performance Metrics
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-853">
          {kpis.map((kpi, index) => <Card key={index} className="p-6 bg-gradient-to-br from-white to-gray-50" data-id="element-854">
              <div className="flex flex-col h-full" data-id="element-855">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide" data-id="element-856">
                  {kpi.title}
                </div>
                <div className="mt-3 text-4xl font-bold text-gray-900" data-id="element-857">
                  {kpi.value}
                </div>
                <div className={`mt-2 text-sm flex items-center font-semibold ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-858">
                  {kpi.isPositive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-859" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-860" />}
                  {kpi.change} vs last quarter
                </div>
              </div>
            </Card>)}
        </div>
      </div>
      {/* Region vs Technician Workload Heatmap */}
      <Card className="p-6 mb-8" data-id="element-861">
        <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-862">
          Region vs Technician Workload Heatmap
        </h3>
        <p className="text-sm text-gray-600 mb-4" data-id="element-863">
          Technician count, average jobs, and utilization by region
        </p>
        <div className="space-y-3" data-id="element-864">
          {regionWorkloadData.map((region, index) => <div key={index} className="space-y-2" data-id="element-865">
              <div className="flex items-center justify-between" data-id="element-866">
                <div className="flex items-center flex-1" data-id="element-867">
                  <span className="text-sm font-semibold text-gray-800 w-32" data-id="element-868">
                    {region.region}
                  </span>
                  <div className="flex items-center space-x-4 text-xs text-gray-600 ml-4" data-id="element-869">
                    <span data-id="element-870">{region.technicians} techs</span>
                    <span data-id="element-871">•</span>
                    <span data-id="element-872">{region.avgJobs} jobs/day</span>
                  </div>
                </div>
                <div className="flex items-center space-x-3" data-id="element-873">
                  <span className="text-sm font-bold text-gray-900 w-12 text-right" data-id="element-874">
                    {region.utilization}%
                  </span>
                </div>
              </div>
              <div className="relative h-8 bg-gray-100 rounded-lg overflow-hidden" data-id="element-875">
                <div className={`h-full ${getUtilizationColor(region.utilization)} transition-all duration-500 flex items-center justify-end px-3`} style={{
              width: `${region.utilization}%`
            }} data-id="element-876">
                  <span className="text-white text-xs font-bold" data-id="element-877">
                    {region.utilization}% utilized
                  </span>
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-878">
          <div className="grid grid-cols-4 gap-4 text-sm" data-id="element-879">
            <div className="text-center" data-id="element-880">
              <div className="text-gray-600" data-id="element-881">Total Technicians</div>
              <div className="text-xl font-bold text-gray-900" data-id="element-882">250</div>
            </div>
            <div className="text-center" data-id="element-883">
              <div className="text-gray-600" data-id="element-884">Avg Utilization</div>
              <div className="text-xl font-bold text-green-600" data-id="element-885">79.4%</div>
            </div>
            <div className="text-center" data-id="element-886">
              <div className="text-gray-600" data-id="element-887">Avg Jobs/Day</div>
              <div className="text-xl font-bold text-gray-900" data-id="element-888">6.9</div>
            </div>
            <div className="text-center" data-id="element-889">
              <div className="text-gray-600" data-id="element-890">Top Region</div>
              <div className="text-lg font-bold text-blue-600" data-id="element-891">Bangalore</div>
            </div>
          </div>
        </div>
      </Card>
      {/* Performance by Technician and Customer Feedback */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-892">
        <Card className="p-6" data-id="element-893">
          <div className="flex items-center justify-between mb-4" data-id="element-894">
            <div data-id="element-895">
              <h3 className="text-lg font-semibold text-gray-800" data-id="element-896">
                Top Performing Technicians
              </h3>
              <p className="text-sm text-gray-600" data-id="element-897">
                Ranked by productivity score
              </p>
            </div>
            <AwardIcon size={20} className="text-yellow-600" data-id="element-898" />
          </div>
          <ResponsiveContainer width="100%" height={350} data-id="element-899">
            <BarChart data={topTechniciansData} layout="vertical" data-id="element-900">
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-901" />
              <XAxis type="number" tick={{
              fontSize: 12
            }} data-id="element-902" />
              <YAxis dataKey="name" type="category" tick={{
              fontSize: 11
            }} width={100} data-id="element-903" />
              <Tooltip contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }} data-id="element-904" />
              <Legend data-id="element-905" />
              <Bar dataKey="productivity" fill="#3b82f6" name="Productivity Score" data-id="element-906" />
            </BarChart>
          </ResponsiveContainer>
          <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-907">
            <div className="grid grid-cols-3 gap-4 text-sm" data-id="element-908">
              <div className="text-center" data-id="element-909">
                <div className="text-gray-600" data-id="element-910">Top Performer</div>
                <div className="text-sm font-bold text-green-600" data-id="element-911">
                  Rajesh Kumar
                </div>
              </div>
              <div className="text-center" data-id="element-912">
                <div className="text-gray-600" data-id="element-913">Avg Score</div>
                <div className="text-xl font-bold text-gray-900" data-id="element-914">82.0</div>
              </div>
              <div className="text-center" data-id="element-915">
                <div className="text-gray-600" data-id="element-916">High Performers</div>
                <div className="text-xl font-bold text-green-600" data-id="element-917">5</div>
              </div>
            </div>
          </div>
        </Card>
        <Card className="p-6" data-id="element-918">
          <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-919">
            Customer Feedback Ratings
          </h3>
          <p className="text-sm text-gray-600 mb-4" data-id="element-920">
            Average ratings across key service dimensions
          </p>
          <ResponsiveContainer width="100%" height={350} data-id="element-921">
            <RadarChart data={feedbackData} data-id="element-922">
              <PolarGrid stroke="#e5e7eb" data-id="element-923" />
              <PolarAngleAxis dataKey="category" tick={{
              fontSize: 11,
              fill: '#6b7280'
            }} data-id="element-924" />
              <PolarRadiusAxis angle={90} domain={[0, 5]} tick={{
              fontSize: 11
            }} data-id="element-925" />
              <Radar name="Rating" dataKey="score" stroke="#3b82f6" fill="#3b82f6" fillOpacity={0.6} data-id="element-926" />
              <Tooltip contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }} formatter={(value: number) => `${value}/5.0`} data-id="element-927" />
            </RadarChart>
          </ResponsiveContainer>
          <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-928">
            <div className="grid grid-cols-3 gap-4 text-sm" data-id="element-929">
              <div className="text-center" data-id="element-930">
                <div className="text-gray-600" data-id="element-931">Overall Rating</div>
                <div className="text-xl font-bold text-green-600" data-id="element-932">4.5/5.0</div>
              </div>
              <div className="text-center" data-id="element-933">
                <div className="text-gray-600" data-id="element-934">Highest</div>
                <div className="text-sm font-bold text-green-600" data-id="element-935">
                  Professionalism
                </div>
              </div>
              <div className="text-center" data-id="element-936">
                <div className="text-gray-600" data-id="element-937">Focus Area</div>
                <div className="text-sm font-bold text-orange-600" data-id="element-938">
                  Problem Solving
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
      {/* Technician Stats Table */}
      <Card className="p-6" data-id="element-939">
        <div className="flex items-center justify-between mb-4" data-id="element-940">
          <div data-id="element-941">
            <h3 className="text-lg font-semibold text-gray-800" data-id="element-942">
              Technician Performance Statistics
            </h3>
            <p className="text-sm text-gray-600" data-id="element-943">
              Detailed metrics for all field technicians
            </p>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-944">
          <table className="w-full" data-id="element-945">
            <thead data-id="element-946">
              <tr className="border-b-2 border-gray-300" data-id="element-947">
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-948">
                  Tech ID
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-949">
                  Name
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-950">
                  Region
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-951">
                  Specialization
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-952">
                  Exp (Yrs)
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-953">
                  Jobs Done
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-954">
                  Jobs/Day
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-955">
                  FTF %
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-956">
                  Avg Time (hrs)
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-957">
                  Rating
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-958">
                  Productivity
                </th>
                <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-959">
                  Certifications
                </th>
                <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-960">
                  Status
                </th>
              </tr>
            </thead>
            <tbody data-id="element-961">
              {technicianStatsData.map((tech, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-962">
                  <td className="py-3 px-4 text-sm font-medium text-blue-600" data-id="element-963">
                    {tech.id}
                  </td>
                  <td className="py-3 px-4 text-sm font-semibold text-gray-800" data-id="element-964">
                    {tech.name}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-700" data-id="element-965">
                    {tech.region}
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-700" data-id="element-966">
                    {tech.specialization}
                  </td>
                  <td className="py-3 px-4 text-sm text-center text-gray-700" data-id="element-967">
                    {tech.experience}
                  </td>
                  <td className="py-3 px-4 text-sm text-right font-medium text-gray-900" data-id="element-968">
                    {tech.jobsCompleted}
                  </td>
                  <td className="py-3 px-4 text-sm text-right font-semibold text-gray-900" data-id="element-969">
                    {tech.avgJobsPerDay}
                  </td>
                  <td className="py-3 px-4 text-sm text-right" data-id="element-970">
                    <span className={getFTFColor(tech.firstTimeFix)} data-id="element-971">
                      {tech.firstTimeFix}%
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-972">
                    {tech.avgResolutionTime}
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-973">
                    <span className={getRatingColor(tech.customerRating)} data-id="element-974">
                      ★ {tech.customerRating}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-975">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-bold ${getProductivityColor(tech.productivity)}`} data-id="element-976">
                      {tech.productivity}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-700" data-id="element-977">
                    {tech.certifications}
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-978">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-bold border ${getStatusColor(tech.status)}`} data-id="element-979">
                      {tech.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-980">
          <div className="grid grid-cols-6 gap-4 text-sm" data-id="element-981">
            <div className="text-center" data-id="element-982">
              <div className="text-gray-600" data-id="element-983">Total Technicians</div>
              <div className="text-xl font-bold text-gray-900" data-id="element-984">12</div>
            </div>
            <div className="text-center" data-id="element-985">
              <div className="text-gray-600" data-id="element-986">Avg Experience</div>
              <div className="text-xl font-bold text-gray-900" data-id="element-987">4.3 yrs</div>
            </div>
            <div className="text-center" data-id="element-988">
              <div className="text-gray-600" data-id="element-989">Avg FTF</div>
              <div className="text-xl font-bold text-green-600" data-id="element-990">76.5%</div>
            </div>
            <div className="text-center" data-id="element-991">
              <div className="text-gray-600" data-id="element-992">Avg Rating</div>
              <div className="text-xl font-bold text-green-600" data-id="element-993">4.4/5.0</div>
            </div>
            <div className="text-center" data-id="element-994">
              <div className="text-gray-600" data-id="element-995">High Performers</div>
              <div className="text-xl font-bold text-green-600" data-id="element-996">5</div>
            </div>
            <div className="text-center" data-id="element-997">
              <div className="text-gray-600" data-id="element-998">Active</div>
              <div className="text-xl font-bold text-green-600" data-id="element-999">11</div>
            </div>
          </div>
        </div>
      </Card>
    </div>;
};
export default TechnicianPerformanceDashboard;